/* eslint-disable import/prefer-default-export */
export const adminInitialState = {
  // TODO why on earth is user in admin state? This should be removed
  user: {},
  adminReports: null,
  // TODO remove this
  adminReportOriginal: null,
  // TODO rename to active report details
  adminReportDetails: {},
  adminHotelReportDetails: {},
  allAgents: [],
  fetchCount: 0,
  paymentProviders: {},
  airlineVouchers: null,
  lossReports: { lossesData: [], count: 0, next: false, previous: false },
  orderLossReports: {},
  // What the signed-in user may do with losses. `loaded` distinguishes "not
  // fetched yet" from "fetched, and the answer is no" — without it every loss
  // button flashes into view on first paint before being taken away again.
  lossCapabilities: { loaded: false, canReportLoss: false, canReviewLoss: false },
  airlineVoucherDetail: null,
  airlineVoucherSupportedAirlines: [],
  refundRequests: { requestsData: [], count: 0, next: false, previous: false },
};
